import { render, staticRenderFns } from "./add-circle.vue?vue&type=template&id=49fc55ac&"
import script from "./add-circle.vue?vue&type=script&lang=js&"
export * from "./add-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49fc55ac')) {
      api.createRecord('49fc55ac', component.options)
    } else {
      api.reload('49fc55ac', component.options)
    }
    module.hot.accept("./add-circle.vue?vue&type=template&id=49fc55ac&", function () {
      api.rerender('49fc55ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/add-circle.vue"
export default component.exports